// @flow
import React from 'react';
import classnames from 'classnames';
import EntryEventModal from './EntryEventModal';
import ReEntryModal from './ReEntryModal';
import './stylesheets/EntryEventHeader.scss';
import type { EventMapping } from '../constants/RailsApiTypes';
import type { VersionConfig } from '../constants/ApiTypes';

type Props = {
  entryEvent: EventMapping,
  editable: boolean,
  orchHasActiveVersion: boolean,
  reEntryLimit: VersionConfig | null
};

type State = {
  showEntryEventModal: boolean,
  showReEntryModal: boolean
};

export const EventCircle = (props: { versionState: string }) => (
  <div className="EntryEventHeader__EventCircleContainer">
    <svg width="32" height="32">
      <circle
        r="16"
        cx="16"
        cy="16"
        className={classnames('EventCircle', {
          EventCircle__Draft: props.versionState === 'draft',
          EventCircle__Active: props.versionState === 'open',
          EventCircle__Closed: props.versionState === 'closed',
          EventCircle__Terminated: props.versionState === 'terminated'
        })}
      />
      <circle r="13" cx="16" cy="16" fill="white" />
    </svg>
  </div>
);

export const LineBreak = () => <div className="Linebreak" />;

export const EntryEventDetail = (props: {
  title: string,
  value: string | number | null
}) => (
  <div className="EntryEventHeader__EntryEvent">
    <span className="EntryEventHeader__EntryEvent__Title">{props.title}</span>
    <span className="EntryEventHeader__EntryEvent__Value">{props.value}</span>
  </div>
);

export default class EntryEventHeader extends React.Component<Props, State> {
  state = { showEntryEventModal: false, showReEntryModal: false };

  toggleModal(flag: string) {
    if (this.props.editable) {
      this.setState({ [flag]: !this.state[`${flag}`] });
    }
  }

  render() {
    const {
      reEntryLimit,
      entryEvent = {},
      editable,
      orchHasActiveVersion
    } = this.props;
    const { showEntryEventModal, showReEntryModal } = this.state;
    const { name } = entryEvent;
    let limit = null;
    let maxTimes = null;
    if (reEntryLimit) {
      if (reEntryLimit.max_times === null && reEntryLimit.reenterable) {
        limit = '';
        maxTimes = 'Unlimited';
      } else if (reEntryLimit.reenterable === false) {
        limit = 0;
        maxTimes = `Users can re-enter up to ${limit}x`;
      } else {
        limit = Number(reEntryLimit.max_times) - 1;
        maxTimes = `Users can re-enter up to ${limit}x`;
      }
    }

    return (
      <div className="EntryEventHeader">
        <div
          className={classnames('EntryEventHeader__Event', {
            'EntryEventHeader__Event--editable': editable
          })}
          onClick={() => this.toggleModal('showEntryEventModal')}
          onKeyDown={() => {}}
          tabIndex="-1"
          role="button"
        >
          <EntryEventDetail title="Entry Event" value={name} />
        </div>
        <EntryEventModal
          showModal={showEntryEventModal}
          currentValue={entryEvent}
          onCloseCallback={() => this.toggleModal('showEntryEventModal')}
        />
        <LineBreak />
        <div
          className={classnames('EntryEventHeader__Event', {
            'EntryEventHeader__Event--editable':
              editable && !orchHasActiveVersion
          })}
          onClick={() => {
            if (!this.props.orchHasActiveVersion) {
              this.toggleModal('showReEntryModal');
            }
          }}
          onKeyDown={() => {}}
          tabIndex="-1"
          role="button"
        >
          <EntryEventDetail title="Re-Entry Limit" value={maxTimes} />
        </div>
        <ReEntryModal
          showModal={showReEntryModal}
          currentValue={limit}
          onCloseCallback={() => this.toggleModal('showReEntryModal')}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/EntryEventHeader.jsx